import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useMemo } from 'react'
import { useParams } from 'react-router-dom';

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import Button from '../../containers/Form/Button'

import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import pathAPICall from '../../app/apiCalls/pathAPICall';
import { path_details, path_edit } from '../../app/apiEndpoints';
import CardHeader from '../../containers/CardHeader';
import Input from '../../containers/Form/Input';
import Select from '../../containers/Form/Select';

const PathsForm = (props) => {
    let { pathType, pathID } = useParams();
    const [path, setPath] = useState({})

    const [inputValue, setInputValue] = useState({ ageMin: 0, ageMax: 0, isActive: true, isCascade: false });
    const [errors, setErrors] = useState({ ageMin: "", ageMax: "", isActive: "", isCascade: "" });
    const { ageMin, ageMax, isActive, isCascade} = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const [hasErrors, setHasErrors] = useState(false)

    const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    useMemo(() => {
        const getDetails = async () => {
            if(pathID > 0) {
                const data = await pathAPICall(path_details, {'pathID': pathID, 'pathType': pathType, 'requester': userID, 'company': companyID })
                setPath(data.path)
                setInputValue({
                    ageMin: data.path.age_min ?? 0, 
                    ageMax: data.path.age_max ?? 0,
                    isActive: data.path.is_active && data.path.is_active === '1' ? 1 : 0,
                    isCascade: data.path.useInAutoFlow && data.path.useInAutoFlow === '1' ? 1 : 0
                })
            }
        }
        getDetails()
    }, [pathID, pathType, userID, companyID])

    const savePath = async () => {
        let formErrors = []
        setHasErrors(false)
        setFormMessage('')
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setHasErrors(true)
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        setStatus(1)

        console.log("active = ", isActive)
        
        const data = await pathAPICall(path_edit, {
            'requester': userID, 
            'company': companyID, 
            'pathID': pathID,
            'pathType': pathType,
            'isActive': isActive,
            'isCascade': isCascade,
            'ageMin': ageMin,
            'ageMax': ageMax
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            setHasErrors(true)
            setStatus(0)
            return
        } 

        if(data.path) {
            setFormMessage("Path Updated")
            setPath(data.path)
            setStatus(0)
        }
    }

    const handleChange = (e) => {
        console.log(e)
        let { name, value } = e.target;

        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };
    
    const handleError = (field, error) => {
        setErrors((prev) => ({
            ...prev,
            [field]: error,
        }));
    };

    const pathName = () => {
        var str = pathType ?? ''
        return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ' Paths';
      }

    if(!path) return <></>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/paths/">Paths</Breadcrumb.Item>
          <Breadcrumb.Item href={`/paths/${pathType}/`}>{pathName()}</Breadcrumb.Item>
          <Breadcrumb.Item active>{path.path}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
                <CardHeader title={path.path} description="Configure Path settings" />
                <Row>
                    <Col md={12}>
                        <Card.Body className='text-left'>
                            <Input
                                type="number"
                                value={ageMin}
                                placeholder="Age Minimum"
                                label="Age Minimum"
                                name="ageMin"
                                onChange={handleChange}
                                onError={handleError}
                                validate="number|required"
                                colSize="2"
                            />
                            <Input
                                type="number"
                                value={ageMax}
                                placeholder="Age Maximum"
                                label="Age Maximum"
                                name="ageMax"
                                onChange={handleChange}
                                onError={handleError}
                                validate="number|required"
                                colSize="2"
                            />
                            <Select 
                                value={isActive} 
                                label="Active" 
                                name="isActive" 
                                onChange={handleChange} 
                                onError={handleError} 
                                colSize={2} 
                                formField="yesno" 
                                useDefault={false} />

                            <Select
                                value={isCascade} 
                                label="In Cascade" 
                                name="isCascade" 
                                onChange={handleChange} 
                                onError={handleError} 
                                colSize={2} 
                                formField="yesno" 
                                useDefault={false} />
                            <p><small>Set age to 0 for no restriction</small></p>

                            <Card.Text className={hasErrors ? "text-danger" : "text-success"}>{formMessage}</Card.Text>
                                    {status === 0 ? <Button title="Update Path" className="primary" onClick={savePath} /> : null}

                        </Card.Body>
                    </Col>
                </Row>    
            </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(PathsForm), "Path Management"));